import * as React from "react";
const SvgFiRrDiceD4 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dice-d4_svg__a)">
      <path
        fill="#062147"
        d="M23.287 12.967 15.155 1.543l-.035-.046a4 4 0 0 0-6.275.046L.7 12.98a4 4 0 0 0 1 5.541l7.666 4.733a4.97 4.97 0 0 0 5.254 0l7.73-4.776a3.984 3.984 0 0 0 .937-5.511M2.822 16.862a1.987 1.987 0 0 1-.48-2.735l8.1-11.378A2 2 0 0 1 11 2.268v19.561a3 3 0 0 1-.576-.276zm18.42-.043-7.666 4.734a3 3 0 0 1-.576.276V2.268c.207.12.392.276.544.461l8.1 11.384a1.98 1.98 0 0 1-.402 2.706"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dice-d4_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDiceD4;
